import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { Grid, Box, Container, Typography } from '@mui/material'
import { api_menu_list } from '../../states/selector'
import { BrowserRouter, Route, Switch, Link, NavLink, useParams, useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import Items from '../../blocks/items'
import UnifiedArchive from '../../blocks/unified-archive'
import { CONFIG } from '../../states/settings'

const MenuList = (props)=>{
  let ul = useLocation()
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)


  useEffect(()=>{
    setMenuList(menu_list)

  }, [])


  return (
    <Box className='wrapper' sx={{
      '@media (max-width: 900px)':{
        padding: 2
      },
      padding: 3
    }}>
    <Grid container spacing={3}>
      <Grid item xs={12} md={8} lg={8} xl={8}>
        { 
          menu_list.map((v,i)=>{
            return (
              <Box key={v.group_name} sx={{
                '@media (max-width: 900px)':{
                  marginTop: i != 0 ? '1.8rem' : 0
                },
                marginTop: i != 0 ? '2rem' : 0
              }}>
                <Box className='Top_menu_name' sx={{
                  '@media (max-width: 900px)':{
                    marginTop: i != 0 ? '1.8rem' : 0
                  }
                }}>
                  <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold', fontSize: '1.5rem', padding: '0 0 15px' }}>
                    { v.group_name }
                  </Typography>
                </Box>
                
                <Items
                  json_file={v.json_file}
                  limit={999999}
                  menu_id={v.group_name}
                  use_pager={false}
                  use_grid={false}
                  show_full={true}
                  from_url={ul.pathname}
                />
              </Box>
            )
          })
        }
      </Grid>
      
      <Grid item xs={12} md={4} lg={4} xl={4}>
        <UnifiedArchive />
      </Grid>
    </Grid>
    </Box>
  )
}

export default MenuList;
